import React from "react";
import { Card, FullModal, Status } from "ui-kit-ck-consultant";
import { ExportCSV } from "react-export-csv";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

import { getPercentageValue } from "../../../utils/general";

const ModalAudit = (props) => {
  const [isDownload, setIsDownload] = React.useState(false);
  const style = {
    div: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-start",
      margin: "10",
    },
    span: {
      paddingLeft: "5px",
    },
  };
  let displayAudit;
  let details = [];
  let csvData = [];
  let csvFilename = "audit";

  if (props.item) {
    for (const [key, value] of Object.entries(props.item)) {
      details.push({ name: key, value: value });
    }
    details = details.filter(
      (it) =>
        it.name !== "data" &&
        it.name !== "length" &&
        it.name !== "active" &&
        it.name !== "id" &&
        it.name !== "shortComment"
    );
    details = details.map((it) => {
      if (it.name === "date" || it.name === "user") {
        it.name = it.name === "date" ? "Date: " : "Expert: ";
      } else if (it.name === "type" || it.name === "reference") {
        it.name = it.name === "type" ? "Type d'Audit: " : "Référence dossier: ";
      } else if (it.name === "comment") {
        it.name = "Commentaire: ";
      } else if (it.name === "value") {
        it.name = "Pourcentage d'atteinte: ";
        it.value = getPercentageValue(it.value);
      }
      return it;
    });

    details.forEach((it) => {
      csvData.push({
        section: "Informations",
        question: it.name.replace(/:\s*$/, ""),
        answer: it.value != null ? String(it.value) : "",
      });
    });

    let tabData = [];
    let data = JSON.parse(props.item.data);

    for (const [key, value] of Object.entries(data)) {
      tabData.push({ name: key, value: value });
    }
    let type = tabData.find((o) => o.name === "type");
    let file = require(`../../../../../data/audit/${"audit-" + type.value + ".json"
      }`);
    let idx = 1;
    displayAudit = file.group.map((el) => {
      return (
        <div key={el.title}>
          <h2>{el.title}</h2>
          {el.data.map((question) => {
            let answer = tabData.find((o) => o.name === `radio-${idx}`) ? tabData.find((o) => o.name === `radio-${idx}`).value : null;
            if (answer === "0" || answer === "1") {
              answer = answer === "0" ? "Non" : "Oui";
            } else answer = "N.C";
            csvData.push({
              section: el.title,
              question: question[0],
              answer: answer,
            });
            idx++;
            return (
              <Card
                key={question[0]}
                className="bg-gray m-10"
                style={style.div}
              >
                <span>{question[0]}</span>
                <Status className={(answer === "Non" ? "bg-red" : answer === "Oui" ?  "bg-green" : "bg-blue") + " ml-10 nowrap"} text={answer} />
              </Card>
            );
          })}
        </div>
      );
    });

    const reference = (props.item.reference || "audit")
      .toString()
      .replace(/[^a-zA-Z0-9-_]/g, "_");
    const date = (props.item.date || "").toString().replace(/[^0-9]/g, "");
    csvFilename = `audit-${reference}${date ? "-" + date : ""}.csv`;
  }

  const component = (
    <>
      {props.item && details ? (
        <>
          {details.map((it) => {
            return (
              <div key={it.name}>
                <h2>{it.name}</h2>
                <Card className="bg-gray m-10">
                  <span>{it.value}</span>
                </Card>
              </div>
            );
          })}
        </>
      ) : null}
      {displayAudit ? displayAudit : null}
    </>
  );

  return (
    <>
      <FullModal
        title="Détails Audit"
        show={props.show}
        onClose={props.hide}
        onCustom={props.item ? () => setIsDownload(true) : null}
        customIcon={faDownload}
      >
        {component}
      </FullModal>
      {isDownload ? (
        <ExportCSV
          header={[
            { name: "Section", key: "section" },
            { name: "Question", key: "question" },
            { name: "Réponse", key: "answer" },
          ]}
          data={csvData}
          separator={";"}
          callback={() => setIsDownload(false)}
          isDownload={true}
          filename={csvFilename}
        />
      ) : null}
    </>
  );
};

export default ModalAudit;
